import { elementRemoveAllEventAndAdd } from '../browser/events';
import { selectElement } from '../browser/selectElement';
import { ds24cart_clear_exec } from './ds24cart_clear';
import { ds24cart_element_id } from './ds24cart_element_id';
import { ds24cart_id } from './ds24cart_id';
import { ds24cart_set_quantity, ds24_on_quantity_change, ds24_on_quantity_change_delayed } from './ds24cart_quantity';
import { ds24cart_show_exec } from './ds24cart_show';
import { ds24_confirm } from './ds24_confirm';
import { ds24_checkout_url } from '../common/ds24_checkout_url';


export function ds24_cart_close(): void {
    document.querySelectorAll('.app_cart_closable').forEach(el => el.classList.remove('open'));
}

export function ds24cart_activate_buttons( selector: string )
{

    const closeableSelector = selector+' .app_dialog_button_close, ' +
        selector + ' .app_cart_tooltip_inner .app_cart_headiline';

    document.querySelectorAll<HTMLElement>(closeableSelector).forEach((div: HTMLElement) => {
        elementRemoveAllEventAndAdd(div, 'click', function() {
            ds24_cart_close();
            selectElement("#app_cart_added_container.open", (el) => el.classList.remove("open"));
        });
    });

    selectElement(selector+' button.app_dialog_button_checkout', checkoutButton => {
        elementRemoveAllEventAndAdd(checkoutButton, 'click', function(e) {
            e.preventDefault();
            const as_popup = checkoutButton.getAttribute('app-as-popup');
            const url = ds24_checkout_url() + '/checkout/' + ds24cart_id();
            if (as_popup) {
                window.open(url);
            } else {
                location.href=url;
            }
            return false;
        });
    });

    selectElement(selector+' button.app_dialog_button_url', (buttonUrl) => {
        elementRemoveAllEventAndAdd(buttonUrl, 'click', function(e){
            e.preventDefault();
            const url = buttonUrl.getAttribute('app-url') as string;
            location.href = url;
            return false;
        });
    });

    if (!window.DS24_TOOLTIP_SHOWN_BY_CLICK) {
        selectElement<HTMLButtonElement>( selector+' button.app_cart_show', buttonCart => {
            elementRemoveAllEventAndAdd(buttonCart, 'mouseenter', function(){
                const _button_id = ds24cart_element_id( buttonCart );
                ds24cart_show_exec( _button_id );
            });
        });
    }

    selectElement<HTMLElement>(selector+' .app_dialog_button_show', buttonShow => {
        elementRemoveAllEventAndAdd(buttonShow, 'click', () => {
                if (selector === '#app_cart_added_container'
                    && document.querySelector<HTMLElement>(selector)?.classList?.contains('open')) {
                    selectElement('#app_cart_added_container', addedContainer => addedContainer.classList.remove('open'));
                    ds24_cart_close();
                    return;
                }
                const _button_id = ds24cart_element_id( buttonShow );
                ds24cart_show_exec( _button_id );
        });
    });

    selectElement<HTMLElement>(selector+' .app_cart_show', el => {
        elementRemoveAllEventAndAdd(el, 'click', () => {
            const _button_id = ds24cart_element_id( el );
            ds24cart_show_exec( _button_id );
        });
    });

    selectElement<HTMLInputElement>(selector+' input.app_cart_quantity', el => {
        elementRemoveAllEventAndAdd(el, 'change', () => {
            ds24_on_quantity_change(el);
        });
    });

    selectElement<HTMLInputElement>(selector+' input.app_cart_quantity', el => {
        elementRemoveAllEventAndAdd(el, 'keyup', () => {
            ds24_on_quantity_change_delayed(el);
        });
    });

    selectElement<HTMLElement>(selector+' .app_cart_delete', el => {
        elementRemoveAllEventAndAdd(el, 'click', (e) => {
            e.preventDefault();
            if (!window.DS24_INFO_STICKY && !ds24_confirm( el )) {
                return false;
            }
            const product_id = el.getAttribute('app-product-id') as string;
            ds24cart_set_quantity( parseInt(product_id, 10), 0 );
            return false;
        });
    });

    selectElement<HTMLElement>(selector+' .app_dialog_button_clear', el => {
        elementRemoveAllEventAndAdd(el, 'click', (e) => {
            e.preventDefault();
            selectElement('.app_cart_closable', el => el.classList.add('hidden'));
            ds24cart_clear_exec();
            return false;
        });
    });
}
